import { forget } from "../../actions/user";
import { user_routes as routes } from "../../constants/routes";
import { FormUtils } from "../../utils/_FormUtils";



const form_nationalCode = localStorage.getItem("FORGET_NC");

$(() => {
    const $national_code = $("#national_code")
    $national_code.val(form_nationalCode);
    $national_code.trigger('focus');

    localStorage.removeItem("FORGET_NC")

    $("form").on("submit", (event) => {
        event.preventDefault();
        const form = $(event.target);
        form.addClass("loading");
        if (FormUtils.validateForm(event.target)) {
            const national_code = form.find("input#national_code").val();
            forget(national_code).then(() => {
                sessionStorage.setItem("NC", national_code)
            }).then(() => {
                window.location.href = routes.auth.forget_otp;
            }).catch(() => {
                if (captcha_google) {
                    FormUtils.renewGoogleCaptcha();
                }
            }).finally(() => {
                form.removeClass("loading");
            });
        } else {
            setTimeout(() => {
                form.removeClass("loading");
            }, 300);
        }
    });
});
